import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function Countdown() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 45,
    seconds: 41
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className="flex flex-col items-center gap-3 my-8" data-id="element-237">
      <div className="flex items-center gap-2 text-cyan-400 font-semibold uppercase tracking-wider text-sm" data-id="element-238">
        <Clock className="w-4 h-4" data-id="element-239" />
        <span data-id="element-240">El precio de lanzamiento cierra en:</span>
      </div>
      <div className="flex gap-4" data-id="element-241">
        {[{
        label: 'Horas',
        value: timeLeft.hours
      }, {
        label: 'Minutos',
        value: timeLeft.minutes
      }, {
        label: 'Segundos',
        value: timeLeft.seconds
      }].map((unit, i) => <div key={i} className="flex flex-col items-center" data-id="element-242">
            <div className="bg-zinc-900 border border-zinc-800 rounded-lg w-16 h-16 flex items-center justify-center text-2xl font-bold text-white shadow-[0_0_15px_rgba(6,182,212,0.15)]" data-id="element-243">
              {unit.value.toString().padStart(2, '0')}
            </div>
            <span className="text-xs text-zinc-500 mt-2 uppercase font-medium" data-id="element-244">
              {unit.label}
            </span>
          </div>)}
      </div>
      <div className="mt-4 w-full max-w-xs" data-id="element-245">
        <div className="flex justify-between text-xs text-zinc-400 mb-1" data-id="element-246">
          <span data-id="element-247">Cupos disponibles</span>
          <span className="text-cyan-400 font-bold" data-id="element-248">72% tomados</span>
        </div>
        <div className="h-2 bg-zinc-900 rounded-full overflow-hidden" data-id="element-249">
          <div className="h-full bg-cyan-500 w-[72%] rounded-full shadow-[0_0_10px_rgba(6,182,212,0.8)]" data-id="element-250" />
        </div>
      </div>
    </div>;
}